import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import {loading} from "../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";

function initPeopleIndex() {
	let productionFilter = document.querySelector('.production-filter');

	const grid = createGrid('.people-grid', {
			columnDefs: [
				{
					field: "first_name",
					headerName: 'First Name',
					sortable: true,
					maxWidth: 180,
				},
				{
					field: "last_name",
					headerName: 'Last Name',
					sortable: true,
					maxWidth: 180,
				},
				{
					field: "last_production_string",
					headerName: 'Last Production',
					sortable: false,
				},
				{
					field: "public_id",
					headerName: '',
					maxWidth: 240,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						return createElement(`
                            <div class="buttons">
                                <a class="btn btn-primary btn-sm" href="${params.data.detail_url}">
                                    <i class="fa-solid fa-circle-info"></i>
                                    Details
								</a>
                            </div>`
						);
					})
				},
			],
			paginationPageSize: 20,
			_rowName: 'Staff',
			rowClass: 'cursor-pointer',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				loading();
				// noinspection JSUnresolvedVariable
				window.location.href = data.detail_url;
			}),
		},
		window['routes/admin.people.grid'],
		() => {
			return {
				production: productionFilter.value
			}
		}
	);
	productionFilter.addEventListener('change', () => {
		grid._refresh();
	})

}

export {
	initPeopleIndex
}
